module.exports = __webpack_public_path__ + "img/sidebar-bell.f08ef8e7.svg";